export default __webpack_public_path__ + "static/img1-90ba6db0932239f1188a5751c3ed5fe0.png";